import { AnyElement, MuWidget } from "mu-widget/lib/MuWidget";
import { DropdownTender } from "./DropdownTender";
import { AWARD_CONTRACT, F03_2014_AWARD_OF_CONTRACT } from "./F03_2014";


export class UiErrorList extends MuWidget {
    beforeIndex(): void {
        this.container.innerHTML += /*html*/`<strong mu-id="bToggle">Seznam chyb</strong>
        <ul mu-id="errors" class="error-navigator__errors">
            <li mu-template="item" mu-widget="UiErrorListItem"></li>
        </ul>`;
        this.container.className = "error-navigator"
    }

    afterIndex(): void {
        this.clear();
    }

    add(message: string, target: AnyElement | null = null) {
        this.muVisible(true, ".");
        return this.muWidgetFromTemplate("item", "errors", { message, target });
    }

    clear() {
        this.ui.errors.innerHTML = "";
        this.muVisible(false, ".");
    }
}

export class UiErrorListItem extends MuWidget {
    public target: AnyElement;
    public message: string;
    afterIndex() {
        (this.container as HTMLElement).innerText = this.message;
        this.prependTenderName();
    }

    container_click() {
        if (this.target) {
            if (this.findParentWithAttribute(this.target as HTMLElement) !== null) {
                const item: F03_2014_AWARD_OF_CONTRACT = (this.findParentWithAttribute(this.target as HTMLElement) as AnyElement).widget as F03_2014_AWARD_OF_CONTRACT;
                const parent: AWARD_CONTRACT = item.muParent as AWARD_CONTRACT;
                const tenderSelect: DropdownTender = parent.tenderSelect;

                if (tenderSelect != null)
                    tenderSelect.changeSelected(tenderSelect.allItems[tenderSelect.allTenders.indexOf(item.container as HTMLElement)]);
            }
            const bodyElement = document.querySelector('.body-layout.layout__middle');

            const calculateRelativeScrollTop = element => {
                const rect = element.getBoundingClientRect();
                return rect.top + bodyElement.scrollTop;
            }

            const nestedElement = (this.target as HTMLElement);
            const relativeScrollTop = calculateRelativeScrollTop(nestedElement);

            bodyElement.scrollTo({
                top: relativeScrollTop - 100,
                behavior: 'smooth',
            });

            this.target.focus();
            const animationDuration = 500;
            this.target.style.animation = "error-navigator-focus " + animationDuration.toString() + "ms ease-in-out";
            setTimeout(() => this.target.style.animation = "", animationDuration);
        }
    }

    public prependTenderName() {
        if (this.findParentWithAttribute(this.target as HTMLElement) !== null) {
            const item: F03_2014_AWARD_OF_CONTRACT = (this.findParentWithAttribute(this.target as HTMLElement) as AnyElement).widget as F03_2014_AWARD_OF_CONTRACT;
            const parent: AWARD_CONTRACT = item.muParent as AWARD_CONTRACT;
            const tenderSelect: DropdownTender = parent.tenderSelect;

            if (tenderSelect != null)
                (this.container as HTMLElement).innerText = (tenderSelect.allItems[tenderSelect.allTenders.indexOf(item.container as HTMLElement)].firstElementChild as HTMLElement).innerText + " - " + (this.container as HTMLElement).innerText;
        }
    }

    public findParentWithAttribute(element: HTMLElement): HTMLElement | null {
        if (element != null) {
            let parent = element.parentElement;

            while (parent) {
                if (parent.getAttribute('mu-widget') === 'F03_2014_AWARD_OF_CONTRACT') {
                    return parent;
                }

                parent = parent.parentElement;
            }

        }
        return null;
    }

    public findParentSection(element: HTMLElement): HTMLElement | null {
        let parent = element.parentElement;

        while (parent) {
            if (parent.hasAttribute("mu-widget")) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return null;
    }
}